import { createFileRoute, Outlet } from "@tanstack/react-router";
import { validateDeviceSearch } from "./-search-params";

/**
 * Pathless layout route for device identification screens.
 * Groups: imei, device-identified, reveal-imei
 */
export const Route = createFileRoute("/$locale/$partner/_device")({
	validateSearch: validateDeviceSearch,
	component: DeviceLayout,
});

function DeviceLayout() {
	return <Outlet />;
}
